var map = {
	"./404.svg": "49be",
	"./auth.svg": "20c3",
	"./batching.svg": "18ce",
	"./code.svg": "d7a0",
	"./data-manage.svg": "fc36",
	"./data-statistic.svg": "99b2",
	"./dispatch.svg": "e4ae",
	"./dispatchtask.svg": "8e57",
	"./drag.svg": "a2f6",
	"./druid.svg": "bc7b",
	"./edit.svg": "2fb0",
	"./fail.svg": "36bc",
	"./order.svg": "81a4",
	"./person.svg": "a59d",
	"./question.svg": "5d9e",
	"./switch.svg": "243e",
	"./system.svg": "922f",
	"./tag.svg": "ac42",
	"./uploading.svg": "e72f",
	"./workbench.svg": "5955"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";